export const translations = {
    trialMessage: {
        es: "Estás probando el plan {{planName}} y lo tenés disponible hasta el {{expirationDate}}",
        en: "You are testing {{planName}} plan and you have it available until {{expirationDate}}"
    },
    buyMessage: {
        es: "Comprar ahora",
        en: "Buy now"
    }
}